import { Alert, AlertIcon, Box, Button, Text } from "@chakra-ui/react";

export default function ImpersonationBanner() {
  const adminToken = localStorage.getItem("admin_token");
  if (!adminToken) return null;

  const impersonatedEmail = localStorage.getItem("impersonated_email") || "user";

  function handleExit() {
    localStorage.setItem("token", adminToken);
    localStorage.setItem("refresh_token", localStorage.getItem("admin_refresh_token") || "");
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_refresh_token");
    localStorage.removeItem("impersonated_email");
    localStorage.removeItem("admin_email");
    window.location.href = "/insighto-admin/users";
  }

  return (
    <Box position="fixed" top={0} left={0} right={0} zIndex={9999}>
      <Alert status="warning" justifyContent="center" gap={4} py={2}>
        <AlertIcon />
        <Text fontWeight="semibold" fontSize="sm">
          Impersonating <strong>{impersonatedEmail}</strong>
        </Text>
        <Button size="xs" colorScheme="red" onClick={handleExit}>
          Exit impersonation
        </Button>
      </Alert>
    </Box>
  );
}
